import React from 'react';
// import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ServicePropOne = ({ colSize, serviceStyle }) => {
	const { t } = useTranslation();

	return (
		<>

			<div className={`${colSize} mt--200 mt_md--0`} >
				<div className={`services-grid ${serviceStyle}`}>
					<div className="thumbnail">
						<img src={process.env.PUBLIC_URL + "/images/SVG/eletricidade.svg"} style={{ minHeight: '80px' }} alt="icon" />
					</div>
					<div className="content">
					<p className="title h5">
							{t('Electricité')}
						</p>
						<p className='m-0'>{t("Notre service électrique, vous assure la tranquillité d'esprit.")}</p>
					</div>
				</div>
			</div>

			<div className={`${colSize} mt--100 mt_md--0`} >
				<div className={`services-grid ${serviceStyle}`}>
					<div className="thumbnail">
						<img src={process.env.PUBLIC_URL + "/images/SVG/renewable_energy.svg"} style={{ minHeight: '80px' }} alt="icon" />
					</div>
					<div className="content">
					<p className="title h5">
							{t('Energie renouvelable')}
						</p>
						<p className='m-0'>{t('Notre service photovoltaïque est conçu pour vous offrir une transition énergétique vers un avenir plus vert et durable')}</p>
					</div>
				</div>
			</div>

			<div className={`${colSize} mt--0`} >
				<div className={`services-grid ${serviceStyle}`}>
					<div className="thumbnail">
						<img src={process.env.PUBLIC_URL + "/images/SVG/informatica.svg"} style={{ minHeight: '100px' }} alt="icon" />
					</div>
					<div className="content">
					<p className="title h5">
							{t('Informatique')}
						</p>
						<p className='m-0'>{t('Notre service informatique vous propose des solutions innovantes')}</p>
					</div>
				</div>
			</div >
		</>
	)
}

export default ServicePropOne;